import { Grid, useEventCallback } from '@mui/material';
import { useCallback } from 'react';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
import { PmiButton } from 'shell/components/shared/button';
import { DatePicker, DateTimePicker } from '@mui/lab';
import Services from 'shell/components/shared/list-service';
import Qualifications from './qualification';
import ListProfile from './profiles';
import PmiTextField from 'shell/components/shared/text-field';
import ListInstitution from './institution';
import { FormOperator, OperatorForm } from 'system/view-models/operator';
import { FormikErrors, FormikTouched } from 'formik';
import { AnprForm } from 'system/view-models/operator';
import OperatorList from 'front-office/components/shared/operator-list';
import { ItemVM } from 'shell/view-models/item';
import { Operator as OperatorM } from 'shell/models/operator';
import { HttpResponse } from 'shell/models/http-response';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import ListTypeOperators from './typeoperators';
import { StationAnprVM } from 'shell/view-models/station-anpr';
import { useBus } from 'shell/hooks/use-bus';
import { ANPR_ACCORDION_EVENT } from './constants';

interface OperatorProps {
  operatorForm?: FormOperator;
  disabled?: boolean;
  disabledTypeOperator?: boolean;
  listOperators?: Array<ItemVM>;
  onChange: (key: keyof FormOperator, value: FormOperator[keyof FormOperator]) => void;
  onChangeTypeOperator: (item?: StationAnprVM) => void;
  onChangeValues: (values: OperatorForm) => void;
  errors?: FormikErrors<FormOperator>;
  touched?: FormikTouched<FormOperator>;
  isEdit?: boolean;
  isRequiredFiscalCode?: boolean;
  isRequiredTypeOperator?: boolean;
  onChangeAnpr: (key: keyof AnprForm, value: AnprForm[keyof AnprForm]) => void;
}

const Operator = ({
  operatorForm,
  disabled = false,
  isEdit = false,
  onChangeTypeOperator,
  errors,
  disabledTypeOperator,
  listOperators,
  touched,
  onChange,
  onChangeValues,
  isRequiredFiscalCode = false,
  isRequiredTypeOperator = false,
  onChangeAnpr,
}: OperatorProps): React.ReactElement => {
  const getOperator = useHttpClient<HttpResponse<OperatorM>, OperatorM>(
    `${__MANAGEMENT_API_URL__}/operatori`,
    {
      transformer: (response) => response.data.payload,
    }
  );
  // const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

  // const handleVisibilityPassword = useEventCallback(() => {
  //   setPasswordVisible((oldPasswordVisibile) => !oldPasswordVisibile);
  // });

  const onChangeFiscalCode = useEventCallback((value: string) => {
    onChange('fiscalCode', value);

    if (isRequiredFiscalCode && operatorForm?.typeOperator === '0') {
      onChangeAnpr('anprOperatorCode', value);
    }
  });

  const eventBus = useBus();

  const updateAnprVisibility = useCallback(
    (open) => {
      eventBus.emit(ANPR_ACCORDION_EVENT, open);
    },
    [eventBus]
  );

  return (
    <Grid item container spacing={2} alignItems="center">
      <Grid container item xs={12} md={12} spacing={2}>
        {disabled || isEdit ? undefined : (
          <Grid item container spacing={2} xs={12} md={12} display="flex" alignItems="center">
            <Grid item xs={12} md={6}>
              <OperatorList
                onChange={(event, operator) =>
                  onChange('operatorSearch', operator as (ItemVM & { operator?: OperatorM }) | null)
                }
                label="Copia profilo da operatore"
                value={operatorForm?.operatorSearch?.id?.toString() || ''}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="contained"
                color="primary"
                onClick={() => {
                  (
                    getOperator({
                      url: `/${operatorForm?.operatorSearch?.operator?.key?.codiceOperatore}`,
                    }) as ResponsePromise<HttpResponse<OperatorM>, OperatorM>
                  ).then((response) => {
                    const operator = response as OperatorM;
                    const [profile] = operator.operatoreProfiloList || [];

                    onChangeValues({
                      operator: {
                        operatorSearch: null,
                        institution: operatorForm?.operatorSearch?.operator?.key?.codiceEnte,
                        // name: operatorForm?.operatorSearch?.operator?.cognomeNome,
                        service: operatorForm?.operatorSearch?.operator?.codiceServizio,
                        qualification:
                          operatorForm?.operatorSearch?.operator?.qualifica?.key?.codiceQualifica,
                        profile: profile?.key?.codiceProfilo,
                        lastUpdate: operatorForm?.operatorSearch?.operator?.note,
                      },
                      feature: {
                        authorizationsList: operator?.tipoFeatureAuthOperatoreList?.map((item) => {
                          const nameTipofeature = item?.descrizioneAutorizzazione || '';
                          const idTipofeature = item?.key?.codiceFeature || '';
                          const descriptionFutureValue = item?.descrizioneValoreFeatureAuthOpe;
                          const value = item?.valoreFeatureAuthOpe;

                          return {
                            id: idTipofeature,
                            type: nameTipofeature,
                            value: `${value} - ${descriptionFutureValue}`,
                          };
                        }),
                      },
                      services: {
                        page: 0,
                        rowsPerPage: 10,
                        servicesList:
                          operator?.operatoreServizioList?.map(
                            (service) => service.key?.codiceServizio
                          ) || [],
                      },
                    });
                  });
                }}
                disabled={!operatorForm?.operatorSearch?.id}
              >
                copia da operatore
              </PmiButton>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} md={4}>
          <PmiTextField
            label="Nome utente *"
            aria-label="utenza estesa"
            id="extCode"
            name="extCode"
            fullWidth
            type="text"
            inputProps={{
              maxLength: '100',
            }}
            variant="outlined"
            value={operatorForm?.extCode || ''}
            disabled={disabled}
            onChange={(event) => onChange('extCode', event.target.value)}
            error={touched?.extCode && Boolean(errors?.extCode)}
            helperText={errors?.extCode}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Scadenza autorizzazioni"
            aria-label="scadenza autorizzazioni"
            value={operatorForm?.authorizationExpiration || null}
            disabled={disabled}
            onChange={(value) => onChange('authorizationExpiration', value)}
            renderInput={(params) => (
              <PmiTextField
                id="authorizationExpiration"
                name="authorizationExpiration"
                {...params}
                fullWidth
                error={false}
                helperText=""
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Data cancellazione"
            aria-label="Data cancellazione"
            value={operatorForm?.cancellationDate || null}
            disabled={disabled}
            onChange={(value) => onChange('cancellationDate', value)}
            renderInput={(params) => (
              <PmiTextField
                id="cancellationDate"
                name="cancellationDate"
                {...params}
                fullWidth
                error={false}
                helperText=""
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} md={8} spacing={2}>
        <Grid item xs={12} md={6}>
          <ListInstitution
            required
            disabled={disabled}
            value={operatorForm?.institution || ''}
            onChange={(event) => onChange('institution', event.target.value)}
            errorSelect={touched?.institution && Boolean(errors?.institution)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ListTypeOperators
            listOperators={listOperators}
            disabledTypeOperator={disabledTypeOperator}
            required={isRequiredTypeOperator}
            updateAnprVisibility={() => updateAnprVisibility(false)}
            value={operatorForm?.typeOperator || ''}
            onChange={onChangeTypeOperator}
            errors={touched?.typeOperator && Boolean(errors?.typeOperator)}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={8}>
        <PmiTextField
          label="Cognome e nome *"
          aria-label="cognome e nome"
          id="name"
          name="name"
          fullWidth
          inputProps={{
            maxLength: '100',
          }}
          type="text"
          variant="outlined"
          value={operatorForm?.name || ''}
          disabled={disabled}
          onChange={(event) => onChange('name', event.target.value)}
          error={touched?.name && Boolean(errors?.name)}
          helperText={errors?.name}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DateTimePicker
          label="Data e ora ultimo collegamento"
          aria-label="Data e ora ultimo collegamento"
          value={operatorForm?.lastLoginDateTime || null}
          disabled={disabled}
          onChange={(value) => onChange('lastLoginDateTime', value)}
          renderInput={(params) => (
            <PmiTextField
              id="lastLoginDateTime"
              name="lastLoginDateTime"
              {...params}
              fullWidth
              error={false}
              helperText=""
            />
          )}
        />
      </Grid>
      <Grid container item xs={12} md={8} spacing={2}>
        <Grid item xs={12} md={6}>
          <PmiTextField
            label={`Codice Fiscale ${isRequiredFiscalCode ? '*' : ''}`}
            aria-label="codice fiscale"
            id="fiscalCode"
            name="fiscalCode"
            fullWidth
            inputProps={{
              maxLength: '16',
            }}
            type="text"
            variant="outlined"
            value={operatorForm?.fiscalCode || ''}
            disabled={disabled}
            onChange={(event) => onChangeFiscalCode(event.target.value)}
            error={touched?.fiscalCode && Boolean(errors?.fiscalCode)}
            helperText={errors?.fiscalCode}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <PmiTextField
            label="CODANA"
            aria-label="CODANA"
            id="codana"
            name="codana"
            fullWidth
            inputProps={{
              maxLength: '16',
            }}
            type="text"
            variant="outlined"
            value={operatorForm?.codAna || ''}
            disabled={disabled}
            onChange={(event) => onChange('codAna', event.target.value)}
            error={touched?.codAna && Boolean(errors?.codAna)}
            helperText={errors?.codAna}
          />
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <PmiTextField
            label="Password"
            aria-label="password"
            id="password"
            name="password"
            fullWidth
            type={passwordVisible ? 'text' : 'password'}
            variant="outlined"
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="cambia visibilità password"
                    onClick={handleVisibilityPassword}
                  >
                    {!passwordVisible ? (
                      <Visibility color="secondary" />
                    ) : (
                      <VisibilityOff color="secondary" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={operatorForm?.password || ''}
            disabled
            onChange={(event) => onChange('password', event.target.value)}
            error={touched?.password && Boolean(errors?.password)}
            helperText={errors?.password}
          />
        </Grid> */}
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={12} md={4}>
          <Services
            disabled={disabled}
            value={operatorForm?.service || ''}
            onChange={(event) => onChange('service', event.target.value)}
            label="Servizio primario *"
            errorSelect={touched?.service && Boolean(errors?.service)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Qualifications
            required
            disabled={disabled}
            value={operatorForm?.qualification || ''}
            onChange={(event) => onChange('qualification', event.target.value)}
            errorSelect={touched?.qualification && Boolean(errors?.qualification)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ListProfile
            required
            disabled={disabled}
            value={operatorForm?.profile || ''}
            onChange={(event) => onChange('profile', event.target.value)}
            errors={touched?.profile && Boolean(errors?.profile)}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <div>
          <PmiTextField
            label="CD operatore *"
            aria-label="codice operatore"
            id="code"
            name="code"
            fullWidth
            type="text"
            inputProps={{
              maxLength: '6',
            }}
            variant="outlined"
            value={operatorForm?.code || ''}
            disabled={disabled}
            onChange={(event) => onChange('code', event.target.value)}
            error={touched?.code && Boolean(errors?.code)}
            helperText={errors?.code}
          />
        </div>
      </Grid>

      <Grid item xs={12} md={4}>
        <PmiTextField
          label="eMail"
          aria-label="email"
          id="email"
          name="email"
          inputProps={{
            maxLength: '100',
          }}
          fullWidth
          type="text"
          variant="outlined"
          value={operatorForm?.email || ''}
          disabled={disabled}
          onChange={(event) => onChange('email', event.target.value)}
          error={touched?.email && Boolean(errors?.email)}
          helperText={errors?.email}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="eMail organiz. appartenenza"
          aria-label="eMail organizzazione appartenenza"
          id="organizationEmail"
          name="organizationEmail"
          fullWidth
          inputProps={{
            maxLength: '100',
          }}
          type="text"
          variant="outlined"
          value={operatorForm?.organizationEmail || ''}
          disabled={disabled}
          onChange={(event) => onChange('organizationEmail', event.target.value)}
          error={touched?.organizationEmail && Boolean(errors?.organizationEmail)}
          helperText={errors?.organizationEmail}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <PmiTextField
          label="Contesto ultimo aggiornamento"
          aria-label="Contesto ultimo aggiornamento"
          id="lastUpdate"
          name="lastUpdate"
          inputProps={{
            maxLength: '50',
          }}
          fullWidth
          type="text"
          variant="outlined"
          value={operatorForm?.lastUpdate || ''}
          disabled={disabled}
          onChange={(event) => onChange('lastUpdate', event.target.value)}
          error={touched?.lastUpdate && Boolean(errors?.lastUpdate)}
          helperText={errors?.lastUpdate}
        />
      </Grid>
    </Grid>
  );
};

Operator.displayName = 'Form Institution component';

export default Operator;
